import React from "react";

function IllustrationAveragePricing() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 97 96">
      <path
        d="M53.67 41.65H43.33a2.963 2.963 0 00-2.953 2.953v49.92c0 .886.59 1.477 1.477 1.477h13.292c.886 0 1.477-.59 1.477-1.477v-49.92a2.963 2.963 0 00-2.954-2.954zM73.608 32.788v61.735c0 .886.59 1.477 1.477 1.477h13.292c.886 0 1.477-.59 1.477-1.477V32.788H73.608zM89.854 29.834V2.954A2.963 2.963 0 0086.9 0H76.561a2.963 2.963 0 00-2.953 2.954v26.88h16.246zM23.392 29.834V19.495a2.963 2.963 0 00-2.953-2.954H10.1a2.963 2.963 0 00-2.954 2.954v10.339h16.246zM7.146 32.788v61.735c0 .886.59 1.477 1.477 1.477h13.292c.887 0 1.477-.59 1.477-1.477V32.788H7.146z"
        className="fill-secondary"
      />
      <path
        d="M95.023 29.834H1.976c-.885 0-1.476.59-1.476 1.477 0 .886.59 1.477 1.477 1.477H95.024c.885 0 1.476-.591 1.476-1.477 0-.887-.59-1.477-1.477-1.477z"
        className="fill-primary"
      />
    </svg>
  );
}

export default IllustrationAveragePricing;
